import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Hero = () => {
  return (
    <section className="relative h-[95vh] min-h-[700px] flex items-center justify-center bg-espresso overflow-hidden">
      {/* Background with parallax-like feel */}
      <div className="absolute inset-0 z-0">
        <motion.img 
          initial={{ scale: 1.1 }}
          animate={{ scale: 1 }}
          transition={{ duration: 10, ease: "linear" }}
          src="https://images.unsplash.com/photo-1611162616475-46b635cb6868?auto=format&fit=crop&q=80&w=2000" 
          alt="Coffee roasting process" 
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-espresso via-transparent to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-espresso/80 via-transparent to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full">
        <div className="max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="h-px w-8 bg-moss"></div>
              <p className="font-handwriting text-2xl text-moss-light tracking-wide italic">The Roaster's Collective — No. 042</p>
            </div>
            
            <h1 className="font-serif text-6xl md:text-8xl lg:text-[10rem] font-bold text-cream mb-8 leading-[0.9] tracking-tighter">
              Origin <br/>
              <span className="text-moss-light">Driven.</span>
            </h1>
            
            <p className="text-lg md:text-xl text-cream-dark mb-12 max-w-lg font-light leading-relaxed">
              Experience the untamed profiles of high-altitude harvests. Sourced with intention, roasted with precision in Portland, Oregon.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-5">
              <button className="group relative bg-moss hover:bg-moss-light text-cream px-10 py-5 rounded-sm font-bold tracking-[0.2em] uppercase text-[11px] transition-all duration-300 overflow-hidden cursor-pointer">
                <span className="relative z-10 flex items-center gap-2">
                  Shop Fresh Roasts <SafeIcon name="ArrowRight" className="group-hover:translate-x-1 transition-transform" />
                </span>
              </button>
              <button className="group border border-cream/20 hover:border-cream/60 text-cream px-10 py-5 rounded-sm font-bold tracking-[0.2em] uppercase text-[11px] transition-all duration-300 cursor-pointer">
                Take the Quiz
              </button>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Bottom Scroll Indicator */}
      <motion.div 
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 2 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-cream/40"
      >
        <span className="text-[10px] uppercase tracking-[0.3em] font-bold">Scroll</span>
        <div className="w-px h-12 bg-gradient-to-b from-moss to-transparent"></div>
      </motion.div>
    </section>
  );
};

export default Hero;